<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/ednote7">EDITOR’S NOTE</a></p>
<p class="toc1"><a href="#/carrillo817">H. G. Carrillo, <i>Splaining Yourself</i></a></p>
<p class="toc1"><a href="#/steger1822">Aleš Šteger, <i>Three Berlin Essays</i> (translated from Slovenian by Brian Henry)</a></p>
<p class="toc1"><a href="#/hodgen2336">Christie Hodgen, <i>Customer Reviews</i></a></p>
<p class="toc1"><span href="#/straub3744" title="Link target outside of Sample">Peter Straub, <i>The Collected Short Stories of Freddie Prothero, Introduction by Törless Magnussen, PhD</i></span></p>
<p class="toc1"><span href="#/vandenberg4562" title="Link target outside of Sample">Laura van den Berg, <i>Havana</i></span></p>
<p class="toc1"><span href="#/olsen6377" title="Link target outside of Sample">Lance Olsen, <i>Dreamlives of Debris</i></span></p>
<p class="toc1"><span href="#/parras78102" title="Link target outside of Sample">John Parras, <i>Song of Magsaysay</i></span></p>
<p class="toc1"><span href="#/welish103111" title="Link target outside of Sample">Marjorie Welish, <i>Folding Cythera</i></span></p>
<p class="toc1"><span href="#/west112124" title="Link target outside of Sample">Paul West, <i>Omobo</i></span></p>
<p class="toc1"><span href="#/baudelaire125145" title="Link target outside of Sample">Charles Baudelaire, <i>Poor Belgium: The Argument</i> (translated from French with an Introduction by Richard Sieburth)</span></p>
<p class="toc1"><span href="#/chernoff146150" title="Link target outside of Sample">Maxine Chernoff, <i>Five Poems</i></span></p>
<p class="toc1"><span href="#/evenson151160" title="Link target outside of Sample">Brian Evenson, <i>Cult</i></span></p>
<p class="toc1"><span href="#/hemley161176" title="Link target outside of Sample">Robin Hemley, <i>Celebrating Russian Federation Day with Immanuel Kant</i></span></p>
<p class="toc1"><span href="#/meidav177189" title="Link target outside of Sample">Edie Meidav, <i>Dog’s Journey</i></span></p>
<p class="toc1"><span href="#/oconnor190214" title="Link target outside of Sample">Stephen O’Connor, <i>The Zip</i></span></p>
<p class="toc1"><span href="#/conoley215226" title="Link target outside of Sample">Gillian Conoley, <i>Preparing One’s Consciousness for the Avatar</i></span></p>
<p class="toc1"><span href="#/xue227240" title="Link target outside of Sample">Can Xue, <i>Coal</i> (translated from Chinese by Annelise Finegan Wasmoen)</span></p>
<p class="toc1"><span href="#/riker241262" title="Link target outside of Sample">Martin Riker, <i>Samuel Johnson’s Eternal Return</i></span></p>
<p class="toc1"><span href="#/weitzel263280" title="Link target outside of Sample">Wil Weitzel, <i>The Gujjar at the River</i></span></p>
<p class="toc1"><span href="#/pitt281295" title="Link target outside of Sample">Matthew Pitt, <i>A Damn Sight</i></span></p>
<p class="toc1"><span href="#/sze296301" title="Link target outside of Sample">Arthur Sze, <i>Water Calligraphy</i></span></p>
<p class="toc1"><span href="#/blackwell302315" title="Link target outside of Sample">Gabriel Blackwell, <i>The Invention of an Island</i></span></p>
<p class="toc1"><span href="#/carter316328" title="Link target outside of Sample">Robyn Carter, <i>Aftershock</i></span></p>
<p class="toc2"><span href="#/contributors329331" title="Link target outside of Sample">Notes on Contributors</span></p>
</div>
<div>
</div>
<div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents56.vue?24a04ca6